import React, { memo } from 'react';
import { Button } from 'antd';
import Btn, { btnTypes } from '../../../../../components/btn';
import styles from './index.module.scss';

const FilterActions = ({
  onReset,
  onApply,
  onCancel,
  resetDisabled = false,
  applyDisabled = false,
}) => {
  return (
    <div className={styles.root}>
      <Btn
        onClick={onReset}
        className={styles.reset}
        disabled={resetDisabled}
        type={btnTypes.secondary}
      >
        Сбросить все
      </Btn>
      <Btn onClick={onApply} className={styles.apply} disabled={applyDisabled}>
        Применить
      </Btn>
      {typeof onCancel === 'function' && (
        <Button type="link" onClick={onCancel} className={styles.cancel}>
          Отменить
        </Button>
      )}
    </div>
  );
};

export default memo(FilterActions);
